// src/jira/issuefieldvalue/types.ts
var JiraIssuefieldvalueAriResourceOwner = "jira", JiraIssuefieldvalueAriResourceType = "issuefieldvalue";

export {
  JiraIssuefieldvalueAriResourceOwner,
  JiraIssuefieldvalueAriResourceType
};
